import React, { useState } from 'react';
import { Box, Typography } from '@heycater/design-system';
import { ButtonBase, useTheme } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useSwipeable } from 'react-swipeable';
import styled from 'styled-components';

import QuotationMark from 'static_pages/home/components/svg/QuotationMark';
import TestimonialImage from 'static_pages/marketing_pages/components/TestimonialImage';

function PartnerQuotes({ content, header }) {
  const theme = useTheme();
  const [currentQuote, setCurrentQuote] = useState(0);
  const [contentPart, setContent] = useState(content[0]);

  const back = () => {
    if (currentQuote > 0) {
      const contentIndex = currentQuote - 1;
      setCurrentQuote(contentIndex);
      setContent(content[contentIndex]);
    } else {
      setCurrentQuote(content.length - 1);
      setContent(content[content.length - 1]);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwiped: ({ dir }) => {
      if (dir === 'Left') {
        next();
      }
      if (dir === 'Right') {
        back();
      }
    },
  });

  const next = () => {
    if (currentQuote < content.length - 1) {
      const contentIndex = currentQuote + 1;
      setCurrentQuote(contentIndex);
      setContent(content[contentIndex]);
    } else {
      setCurrentQuote(0);
      setContent(content[0]);
    }
  };
  return (
    <div {...swipeHandlers}>
      <Box textAlign="center">
        <Typography
          variant="h3"
          mt={{ xs: 6, sm: 10 }}
          xs={{ lineHeight: 1.5 }}
          px={{ sm: 15, md: 10 }}
        >
          {header}
        </Typography>
      </Box>
      <Box
        key={contentPart.fields.name}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{ xs: 'column', md: 'row' }}
        mt={5}
        mb={{ xs: 0, md: 10 }}
      >
        <Box
          display="flex"
          flexDirection={{ xs: 'row', md: 'column' }}
          alignItems="center"
          minWidth={176}
          mr={{ xs: 0, md: 8 }}
          justifyContent="flex-start"
        >
          <Box
            position="relative"
            width={{ xs: 118, md: 176 }}
            height={{ xs: 118, md: 176 }}
            border="solid 4px"
            borderColor={theme.palette.text.disabled}
            borderRadius={500}
          >
            {contentPart.fields.image && (
              <TestimonialImage {...contentPart.fields.image} />
            )}
          </Box>
          <Box textAlign={{ xs: 'left', md: 'center' }} ml={{ xs: 4, md: 0 }}>
            <Typography variant="subtitle1" mt={{ xs: 0, sm: 4 }}>
              {contentPart.fields.name}
            </Typography>
            <Typography variant="caption">
              {contentPart.fields.company}
            </Typography>
          </Box>
        </Box>
        <Box
          position="relative"
          mr={{ xs: 3, md: 9 }}
          ml={{ xs: 3, md: 0 }}
          flexGrow={2}
          mt={{ xs: 5, md: 0 }}
        >
          <Typography variant="subtitle2" mb={4}>
            {contentPart.fields.body}
          </Typography>
          <Box position="absolute" bottom={4} right={0}>
            <QuotationMark />
          </Box>
        </Box>
        <StyledBox mb={4}>
          <ButtonBase onClick={back}>
            <ArrowBackIosIcon color="disabled" fontSize="large" />
          </ButtonBase>
          <ButtonBase onClick={next}>
            <ArrowForwardIosIcon fontSize="large" />
          </ButtonBase>
        </StyledBox>
      </Box>
    </div>
  );
}

const StyledBox = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: ${(props) => props.theme.spacing(4)}px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    align-self: flex-end;
    padding-top: ${(props) => props.theme.spacing(2)}px;
  }
`;

export default PartnerQuotes;
